(ns app.components.pop-ups.views
  (:require [app.components.buttons.views :as buttons]
            [app.components.checkbox.views :as checkbox]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [warning-icon]]
            [app.components.pop-ups.styles :refer [parent-checkbox-style
                                                   popper-style]]
            [clojure.string :as s]
            [re-com.core :as re-com :refer [at box h-box modal-panel v-box]]
            [reagent-mui.material.box :as mui-box]
            [reagent-mui.material.popper :refer [popper]]
            [reagent-mui.material.snackbar :refer [snackbar]]
            [reagent.core  :as reagent]))

(defn dialog-markup-folder
  [{:keys [main-text sub-text alt-text on-cancel on-confirm cancel-button-text confirm-button-text]}]
  [v-box :src (at)
   :padding  "8px"
   :gap "16px"
   :justify :center
   :align :center
   :width "308px"
   :style {:font-size "35px"}
   ;;:class (warning-popup-style)
   :children [[v-box
               :justify :center
:align :center
               :children [[warning-icon {:size "35px"}]
                          [header {:label  main-text :type :small :size :semibold
                                   :style {:text-align "center" :display "block" :font-size "16px"}}]
                          (when sub-text [header {:label sub-text :type :normal :size :regular
                                                  :style {:text-align "center" :display "block" :font-size "16px"}}])]]

              [h-box :src (at)
               :gap      "8px"
               :style {:display "flex"}
               :children [[box
                           :width "45%"
                           :child [buttons/button {:action :cta :type :secondary
                                                   :title cancel-button-text
                                                   :size :medium
                                                   :onClick on-cancel}]]
                          [box
                           :width "45%"
                           :child [buttons/button {:action :warning
                                                   :type :primary
                                                   :title confirm-button-text
                                                   :size :medium
                                                   :onClick on-confirm}]]]]]])

(defn pop-up [{:keys [main-text sub-text alt-text on-cancel  on-confirm cancel-button-text confirm-button-text continue-button-text deletable?]}]
  [modal-panel :src (at)
   :backdrop-color   "grey"
   :backdrop-opacity 0.4
   :child            [dialog-markup-folder {:main-text main-text :sub-text sub-text :alt-text alt-text :on-cancel on-cancel :on-confirm on-confirm :cancel-button-text cancel-button-text :confirm-button-text confirm-button-text :continue-button-text continue-button-text :deletable? deletable?}]])

(defn mui-snackbar [{:keys [open main-text]}]
  [snackbar {:open @open
             :anchorOrigin {:vertical "bottom" :horizontal "center"}
             :autoHideDuration 2000
             :onClose (fn [^js/Event e]
                        (swap! open not))
             :message (str main-text)}])

(defn undo-action-button [title action open]
  [:<>
   [buttons/button {:action :cta :type :tertiary
                    :style {:color "white"}
                    :title title
                    :size :small :onClick #(do (action)
                                               (swap! open not))}]])

(defn mui-action-snackbar [{:keys [open main-text title action]}]
  [snackbar {:open @open
             :anchorOrigin {:vertical "bottom" :horizontal "center"}
             :autoHideDuration 2000
             :onClose (fn [^js/Event e]
                        (swap! open not))
             :message (str main-text)
             :action (reagent/as-element [undo-action-button title action open])}])

(defn mutliselect-actions-pop-up [{:keys [selected? global-ticked? array-of-ticked selected-all-ticked? assets-selected all-assets actions]}]
  [popper {:id "trash-popper"
           :open @selected?
           :anchorEl @selected?
           :placement "bottom-end"
           :modifiers {:offset {:enabled true :offset "0, 30"}}
           :class (popper-style)}
   [mui-box/box {:sx {:display "flex" :align-items "center"}}
    [:div
     [checkbox/select-all-checkbox-component {:class (parent-checkbox-style)
                                              :name name
                                              :selected? selected?
                                              :global-ticked? global-ticked?
                                              :selected-all-ticked? selected-all-ticked?
                                              :all-assets all-assets
                                              :assets-selected assets-selected
                                              :array-of-ticked array-of-ticked}]]
    (map (fn [value]
           [:div {:id (:id value)}
            [buttons/button {:action :cta
                             :type :secondary
                             :title (:title value)
                             :size :large
                             :onClick (:action value)
                             :style {:color "#EBEBFF" :background-color "#2B2A35" :border-radius "0" :border-color "transparent"}}]]) actions)]])